import { Dialog, DialogContent, IconButton, styled } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { ChatMessageContact } from '@src/types';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import ChatMessageContactCard from './ChatMessageContactCard';

export type ChatMessageContactsDialogProps = {
  isOpenContactsDialog: boolean;
  onCloseContactsDialog: () => void;
  contacts?: ChatMessageContact[];
};

const ChatMessageContactsDialog: React.FC<ChatMessageContactsDialogProps> = ({
  isOpenContactsDialog,
  onCloseContactsDialog,
  contacts,
}) => {
  const { formatMessage } = useIntl();
  const qtyContacts = useMemo(() => contacts?.length || 0, [contacts]);
  return (
    <Dialog
      fullWidth
      open={isOpenContactsDialog}
      onClose={() => onCloseContactsDialog()}
      PaperProps={{ style: { borderRadius: 0 } }}
    >
      <DialogContent style={{ padding: 0, borderRadius: 0 }}>
        <ChatMessageContactDialogStyles>
          <div className="contact-title">
            <IconButton size="small" onClick={() => onCloseContactsDialog()}>
              <ClearIcon style={{ fontSize: '1.4rem', color: '#fff' }} />
            </IconButton>
            {qtyContacts > 1 &&
              formatMessage(
                { id: 'Console.ContactMessage.DialogTitleContacts' },
                { qty: contacts?.length || 0 }
              )}

            {qtyContacts === 1 &&
              formatMessage({
                id: 'Console.ContactMessage.DialogTitleContact',
              })}
          </div>
          {contacts?.map(contact => (
            <ChatMessageContactCard
              key={contact.name.first_name}
              contact={contact}
            />
          ))}
        </ChatMessageContactDialogStyles>
      </DialogContent>
    </Dialog>
  );
};

const ChatMessageContactDialogStyles = styled('div')({
  '& .contact-title': {
    padding: 25,
    backgroundColor: '#7C69FF',
    color: '#fff',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gridGap: 5,
  },
});

export default ChatMessageContactsDialog;
